export default "__VITE_ASSET__3bbf794d__"